import { createUseStyles } from 'react-jss'

export default createUseStyles({
  button: ({ isMaxPillLength }) => isMaxPillLength ? { minWidth: '300px' } : { minWidth: '120px' },
  icon: ({ isLoading }) => ({
    flexShrink: '0 ',
    '--icon__primary__fill__color': 'var(--card__icon__loader_color)',
    '& path': {
      stroke: isLoading ? 'transparent' : 'var(--card_icon_color)'
    }
  }),
  title: {
    fontFamily: 'BentonSansMedium',
    marginLeft: '10px !important'
  }
})
